export const pt = {
  hero: {
    title: "Negocie <span>Mais Inteligente</span> com OKX + METRADE",
    subtitle: "Estratégias de trading profissionais agora acessíveis a todos",
    startTrading: "Comece a Negociar Agora",
    learnMore: "Saiba Mais Sobre OKX",
    poweredBy: "Com tecnologia de",
    socialProof: "Junte-se a mais de 50.000 traders que aumentaram seu desempenho de trading"
  },
  promo: {
    signUp: "Inscreva-se hoje e obtenha",
    months: "3 MESES GRÁTIS",
    worth: "Valor de 3x29$ • Economize 87$",
    limitedTime: "Oferta por tempo limitado! Expira em breve"
  },
  whyMetrade: {
    title: "Por Que Escolher METRADE",
    subtitle: "O parceiro perfeito para sua jornada de trading no OKX",
    reason1: {
      title: "Estratégias Verificadas",
      description: "Todas as estratégias premium têm históricos comprovados e são rigorosamente avaliadas"
    },
    reason2: {
      title: "Gestão de Risco",
      description: "Controles de risco avançados integrados em cada estratégia premium para proteger seu capital"
    },
    reason3: {
      title: "Qualidade Suíça",
      description: "Construído na Suíça com precisão, confiabilidade e segurança"
    },
    reason4: {
      title: "Integração Perfeita",
      description: "Siga a estratégia em sua conta OKX sem necessidade de conhecimentos técnicos"
    },
    reason5: {
      title: "Transparência Total",
      description: "Acesse dados de desempenho em tempo real e histórico completo de trading"
    },
    reason6: {
      title: "Suporte Especializado",
      description: "Equipe dedicada de profissionais prontos para ajudá-lo"
    }
  },
  steps: {
    title: "Inicie Sua Jornada de Trading",
    subtitle: "Comece em três passos simples",
    step1: {
      title: "Cadastre-se gratuitamente",
      description: "Crie sua conta em segundos apenas com seu email"
    },
    step2: {
      title: "Selecione uma Estratégia",
      description: "Navegue por estratégias adaptadas especificamente para traders do OKX"
    },
    step3: {
      title: "Conecte e Comece",
      description: "Selecione sua estratégia com nossa configuração guiada e comece a negociar"
    },
    joinText: "Junte-se a milhares de usuários bem-sucedidos no METRADE"
  },
  stats: {
    title: "Desempenho Comprovado",
    subtitle: "Nossa plataforma oferece resultados consistentes para traders em todo o mundo",
    activeUsers: "Usuários Ativos em mais de 100 países",
    tradingVolume: "Volume de Trading processado diariamente",
    successRate: "Taxa de satisfação das pesquisas",
    support: "Suporte Prioritário em vários idiomas"
  },
  features: {
    title: "METRADE Marketplace",
    subtitle: "Junte-se a milhares de usuários bem-sucedidos que transformaram sua experiência de trading",
    feature1: {
      title: "Estratégias Comprovadas",
      description: "Acesse estratégias de trading testadas em batalha com taxas de sucesso verificadas de até 95%"
    },
    feature2: {
      title: "Gestão de Risco",
      description: "Parâmetros de risco pré-definidos protegem seu capital durante a volatilidade do mercado"
    },
    feature3: {
      title: "Selecione Estratégia",
      description: "Selecione sua estratégia no OKX e siga com 2 cliques"
    }
  },
  strategyShowcase: {
    title: "Estratégias de Melhor Desempenho",
    subtitle: "Descubra nossas estratégias de trading mais bem-sucedidas disponíveis no OKX",
    viewAll: "Ver Todas as Estratégias",
    strategy1: {
      name: "Mestre do Momentum",
      description: "Captura tendências de mercado com pontos de entrada e saída precisos",
      roi: "+187% ROI em 2023",
      winRate: "78% Taxa de Vitória",
      riskLevel: "Risco Médio"
    },
    strategy2: {
      name: "Vantagem da Volatilidade",
      description: "Prospera em mercados voláteis com parâmetros de trading adaptativos",
      roi: "+215% ROI em 2023",
      winRate: "82% Taxa de Vitória",
      riskLevel: "Risco Médio-Alto"
    },
    strategy3: {
      name: "Crescimento Estável",
      description: "Abordagem conservadora focada em retornos consistentes",
      roi: "+95% ROI em 2023",
      winRate: "91% Taxa de Vitória",
      riskLevel: "Baixo Risco"
    },
    okxCompatible: "Otimizado para OKX"
  },
  testimonials: {
    title: "Histórias de Sucesso",
    subtitle: "Ouça traders que já estão se beneficiando de nossas estratégias",
    testimonial1: {
      quote: "Desde que conectei minha conta OKX com o METRADE, meu trading foi completamente transformado. Agora vejo retornos consistentes onde antes enfrentava perdas constantes. As estratégias automatizadas se adaptam às condições de mercado mais rapidamente do que eu jamais poderia.",
      author: "Alex K.",
      location: "Reino Unido",
      strategy: ""
    },
    testimonial2: {
      quote: "O que mais me impressiona na integração OKX-METRADE é a transparência. Posso ver cada negociação, monitorar o desempenho em tempo real e ter controle total enquanto a estratégia faz o trabalho pesado.",
      author: "Mei L.",
      location: "Singapura",
      strategy: ""
    },
    testimonial3: {
      quote: "Como um profissional ocupado, eu nunca tinha tempo para analisar gráficos o dia todo. As estratégias do METRADE no OKX me permitiram participar dos mercados de criptomoedas com execução de nível profissional sem sacrificar meu trabalho diário.",
      author: "Raj P.",
      location: "Índia",
      strategy: ""
    }
  },
  faq: {
    title: "Perguntas Frequentes",
    subtitle: "Encontre respostas para perguntas comuns sobre a integração METRADE e OKX",
    question1: {
      question: "Como funciona a integração OKX-METRADE?",
      answer: "Nossa plataforma se conecta à sua conta OKX através de um Link secreto com permissões de seguimento. Uma vez conectada, as estratégias que você selecionar executarão automaticamente negociações em seu nome com base em parâmetros predefinidos. Você precisa de uma conta OKX para seguir uma estratégia"
    },
    question2: {
      question: "Qual é o capital mínimo necessário para começar?",
      answer: "O mínimo é 2000 USDT para uma Estratégia Gratuita. O mínimo de 2500 USDT é uma Estratégia Premium com Gerenciamento de Risco."
    },
    question3: {
      question: "Como posso monitorar e controlar meu risco?",
      answer: "Cada estratégia Premium vem com configurações de gerenciamento de risco integradas que você pode revisar antes de ativar. Você pode definir limites máximos de drawdown, e nossa plataforma interromperá automaticamente o trading se esses limites forem atingidos."
    },
    question5: {
      question: "O que acontece se eu quiser parar de usar uma estratégia?",
      answer: "Você pode pausar ou desconectar uma estratégia a qualquer momento com um único clique. Isso interromperá imediatamente quaisquer novas negociações, oferecendo opções para gerenciar posições abertas existentes."
    },
    question6: {
      question: "Existem taxas ocultas?",
      answer: "Não. Cobramos uma taxa de assinatura mensal transparente com base no plano escolhido. Não há comissões adicionais sobre lucros ou cobranças ocultas. Você paga apenas as taxas de trading padrão da OKX."
    }
  },
  footer: {
    copyright: "Todos os direitos reservados."
  },
  languageSelector: {
    language: "Idioma"
  },
  cta: {
    title: "Pronto para transformar seu trading?",
    subtitle: "Comece com um teste gratuito de 3 meses hoje",
    buttonText: "Cadastre-se Gratuitamente",
    noCredit: "Não é necessário cartão de crédito para o teste gratuito"
  }
};
